/*
 * Project: LegalPlace assistant
 * File: src\components\utils\credit_card_detect.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/


function checkVisa(cn = '') {
  return (cn.search(/^4[0-9]/g) === 0);
}

function checkMasterCard(cn = '') {
  return (cn.search(/^5[1-5]/g) === 0);
}

function checkAmex(cn = '') {
  return (cn.search(/^3[47]/g) === 0);
}


export function getCardClass(cn = '') {
  if (checkVisa(cn)) return 'visa';
  if (checkMasterCard(cn)) return 'master';
  if (checkAmex(cn)) return 'amex';
  return 'none';
}

window.card_class = getCardClass;



// WEBPACK FOOTER //
// ./src/components/utils/credit_card_detect.js